import { Box, Tooltip } from "@mui/material";
import Translate from "../../utils/Translate";
import { AccessTime, Delete, Done, Warning } from "@mui/icons-material";
import { digitalLicenseStatus } from "../../utils/actorLicense";

export default function DigitalLicenseColumn({ license }) {
  const hasDigitalLicense = !!license.digitalLicenseId;
  if (!hasDigitalLicense) {
    return null;
  }

  const showArchiveRequestInfo = license.hasArchiveRequest;
  const showDigitalLicenseStatusProcessing = license.digitalLicenseStatus != digitalLicenseStatus.published;
  const showDigitalLicenseBounce = license.digitalLicenseMessageBounce;

  if (showArchiveRequestInfo) {
    const hasSentArchiveRequest = !!license.archiveRequestMessageSendDate;
    const showArchiveRequestWillBeSent = !hasSentArchiveRequest;
    const showArchiveRequestBounce = hasSentArchiveRequest && license.archiveRequestMessageBounce;
    const showWaitingForResponse =
      hasSentArchiveRequest && !showArchiveRequestBounce && !license.archiveRequestHasResponse;
    const showWaitingForDelete =
      hasSentArchiveRequest && !showArchiveRequestBounce && license.archiveRequestHasResponse;
    return (
      <Box>
        {showArchiveRequestWillBeSent && (
          <Tooltip arrow className="iconbox" title={Translate.get("ArchiveRequestWaitingForSend")}>
            <Delete />
          </Tooltip>
        )}
        {showArchiveRequestBounce && (
          <Tooltip arrow className="iconbox warning" title={Translate.get("ArchiveRequestMessageToStudentBounced")}>
            <Warning />
          </Tooltip>
        )}
        {showWaitingForResponse && (
          <Tooltip arrow className="iconbox" title={Translate.get("ArchiveRequestWaitingForResponse")}>
            <Delete />
          </Tooltip>
        )}
        {showWaitingForDelete && (
          <Tooltip arrow className="iconbox" title={Translate.get("ArchiveRequestWaitingForDelete")}>
            <Delete />
          </Tooltip>
        )}
      </Box>
    );
  } else if (showDigitalLicenseStatusProcessing) {
    return (
      <Box>
        <Tooltip arrow className="iconbox" title={Translate.get("DigitalLicenseStatusIsNotPublished")}>
          <AccessTime />
        </Tooltip>
      </Box>
    );
  } else if (showDigitalLicenseBounce) {
    return (
      <Box>
        <Tooltip arrow className="iconbox warning" title={Translate.get("DigitalLicenseMessageToStudentBounced")}>
          <Warning />
        </Tooltip>
      </Box>
    );
  } else {
    return (
      <Box>
        <Tooltip arrow title={Translate.get("HasDigitalLicense")}>
          <Done />
        </Tooltip>
      </Box>
    );
  }
}
